import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import * as Sentry from '@sentry/angular';
import { environment } from './environments/environment';
import LogRocket from 'logrocket';

if (environment.sentryDSN !== null) {
  Sentry.init({
    dsn: environment.sentryDSN,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 1.0,
  });

  LogRocket.init('ventureanywhere/oracy-champions');

  LogRocket.getSessionURL((sessionURL) => {
    Sentry.withScope((scope) => {
      scope.setExtra('sessionURL', sessionURL);
    });
  });
}

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
